<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h4>Featured Article</h4>
            </div>
        </div>
        <div class="row py-3">
            <div class="col-12 col-md-6 order-1 order-md-1">
                <span class="btn btn-dark">{{ featured_post.type }}</span>
                <span class="ml-1">{{ featured_post.post_date }}</span>
                <div class="post_content py-1">
                    <h5>{{ featured_post.title }}</h5>
                    <div class="excerpt py-2">{{ featured_post.excerpt }}</div>
                    <div class="post_link">
                        <a class="btn btn-primary" :href="featured_post.permalink" target="_blank">Read Full Article</a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 order-1 order-md-2">
                <div class="img-container">
                    <img :src="featured_post.featured_img" :alt="featured_post.img_alt">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['featured_post'],
    data() {
        return {
        }
    },

}
</script>
